import axios from "axios";
import auth from "../auth";
import { throwBackendError } from "./request-exception.js";

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

http.interceptors.request.use(
  function(config) {
    config.headers["Authorization"] = "Bearer " + auth.getToken();
    return config;
  },
  function(error) {
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    if (err.response.status == 403 && auth.tokenIsExpired() && err.config._retry !== true) {
      err.config._retry = true;
      const refreshTokenRequestSettings = {
        url: "/token",
        method: "post",
        data: `grant_type=refresh_token&refresh_token=${auth.getRefreshToken()}`,
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
      };
      const refreshPromise = http(refreshTokenRequestSettings)
        .then(res => {
          auth.login(
            res.data.access_token,
            res.data.refresh_token,
            res.data.expires_in,
          );
          err.config.headers.Authorization = res.data.refresh_token;
          return http(err.config);
        })
        .catch(function(err) {
          if (err.message) {
            return Promise.reject(err);
          } else {
            console.log(err);
            auth.logout();
            window.location = "/";
            return;
          }
        });
      return Promise.resolve(refreshPromise);
    } else if (err.response && typeof err.response.data === "string") {
      return throwBackendError(err);
    } else {
      return Promise.reject(err);
    }
  },
);
